import { useState } from "react";
import { Grid, Box, Typography, IconButton, Button } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { selectSectorWorkflow } from "../../../../../../../../../../redux/features/quotes/quote-create-advanced/selectors/sectorWorkflowSelectors";
import { useAppDispatch, useAppSelector } from "../../../../../../../../../../redux/hooks/redux";
import { useOtherAreasPagination } from "../../hooks/useOtherAreasQuery";
import { QueryState } from "../../../../../../../../../shared/components/query-states/GlobalQueryState";
import { OtherAreasCardSelectable } from "./components/OtherAreasCard";
import { SASButtonStyles } from "../../../../../../../../../ui/styles/inputStyles";
import { quoteCreateActions } from "../../../../../../../../../../redux/features/quotes/quote-create-advanced";
import { useModals } from "../../../../../../../../../../context/ModalContext";

export const OtherAreas = () => { 
  const workflowData = useAppSelector(selectSectorWorkflow);
  const { closeByKey } = useModals()

  const category = workflowData.category.name;
  const typeOfService = workflowData.service.name;
  const selectedMainAreas = workflowData.areas;
  const selectedOtherAreas = workflowData.otherAreas;

  const dispatch = useAppDispatch();
  const { setOtherAreas } = quoteCreateActions;

  const [tempSelectedAreas, setTempSelectedAreas] = useState(selectedOtherAreas || []);

  const {
    items,
    isLoading,
    isError,
    goNextPage,
    goPrevPage,
    page,
    totalPages,
  } = useOtherAreasPagination({
    category,
    typeOfService,
  });

  const extraAreas = items?.filter(
    (area) => !selectedMainAreas.some((a) => a.uid === area.uid)
  );

  const handleToggle = (area) => {
    setTempSelectedAreas((prev) => {
      const exists = prev.find((x) => x.uid === area.uid);
      if (exists) {
        return prev.filter((x) => x.uid !== area.uid);
      }
      return [...prev, area];
    });
  };

  const handleConfirm = () => {
    dispatch(setOtherAreas(tempSelectedAreas));
    closeByKey("Other-Areas-Selector")
  };

  const handleOnClose = () => {
  closeByKey("Other-Areas-Selector")
  }

  if (isLoading || isError) {
    return (
      <QueryState
        serviceName="Other Areas"
        isLoading={isLoading}
        isError={isError}
      />
    );
  }

  return (
    <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "var(--fx-surface-base, #FFFFFF)",
          mb: 2,
        }}
      >
        <IconButton onClick={goPrevPage} disabled={page === 1}>
          <ChevronLeft fontSize="large" />
        </IconButton>

        <Typography fontWeight={700}>
          Page {page} / {totalPages}
        </Typography>

        <IconButton onClick={goNextPage} disabled={page === totalPages}>
          <ChevronRight fontSize="large" />
        </IconButton>
      </Box>

      {/* GRID */}
      <Grid container spacing={2} sx={{ flexGrow: 1, overflowY: "auto" }}>
        {extraAreas.map((area) => (
          <Grid item xs={6} sm={4} md={3} key={area.uid}>
            <OtherAreasCardSelectable
              area={area}
              selected={!!tempSelectedAreas.find((x) => x.uid === area.uid)}
              onToggle={() => handleToggle(area)}
            />
          </Grid>
        ))}
      </Grid>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pt: 2,
          borderTop: "1px solid var(--fx-surface-border, #E2E8F0)",
          mt: 2,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {tempSelectedAreas.length} area(s) selected
        </Typography>

        <Box sx={{ display: "flex", gap: 1, p: 2 }}>
          <Button
            onClick={handleOnClose}
            variant="outlined"
            sx={{
              textTransform: "none",
              borderColor: "var(--fx-surface-borderstrong, #CBD5E1)",
              color: "var(--fx-surface-textsecondary, #64748B)",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            sx={{ ...SASButtonStyles }}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Box>
  );
};